import React, { useState } from 'react';
import './webinar.css';
import { Avatar, Checkbox, FormControl, IconButton, Input, InputAdornment, TextField } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import CloseBtn from '../MeetingDrawer/closeBtn';
import SearchIcon from '@material-ui/icons/Search';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import GradientButton from '../customMui/newButton/newButton';

function WebQA({ setSideComp, handleClose, isModerator })
{

	const [ reply, setReply ] = useState(false);

	const displayName = 'Shantanu';

	const hanleCloseQa = () =>
	{
		handleClose();
		setSideComp('');
	};

	const getInitials = () =>
	{
		// if (displayName)
		// {
		const words = displayName.split(' ');

		if (words.length > 1)
		{
			return `${words[0].charAt(0).toUpperCase()}${words[1].charAt(0).toUpperCase()}`;
		}
		else if (words.length === 1)
		{
			return words[0].slice(0, 2).toUpperCase();
		}
		// }

		// return '';
	};
	const [ anchorEl, setAnchorEl ] = React.useState(null);

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	const handleClickClose = () =>
	{
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<div className='flexCol approvedHostHg ' > {/* use approvedparticipantHg class for participant height*/}

			{/* <div className='flexRow aCntr jBtwn pdngXS'>
				{ isModerator ?
					<CloseBtn/> :
					<img src='icons/close.svg' alt='back' className='pointer' onClick={hanleCloseQa}/>
				}
				<div className='flexMinWidthCol aCntr'><span className='mHdng' >Q&A</span></div>
			</div> */}

			<div className='flexRow pdngHMD'>
				<Input
					style={{
						color        : 'black',
						fontSize     : '16px',
						fontWeight   : '400',
						borderBottom : '2px solid #BBD4DD',
						padding      : '4px'
					}}
					placeholder='Search by name'
					label='Search By Name'
					fullWidth
					disableUnderline
					className='search'
					startAdornment={
						<InputAdornment position='start'>
							<SearchIcon style={{ color: '#BBD4DD', fontSize: '32px' }} />
						</InputAdornment>
					}
				/>

			</div>
			<div className='flexRow pdngSM'>
				<div className='flexMinWidthRow pdngHXS'>
					<span>Total <span className='link'>(3)</span></span>

				</div>
				<div className='flexAutoRow pdngHXS pointer'>
					<img src='/icons/filter.svg' alt='filter' onClick={handleClick} />

				</div>

				<Popover
					id={id}
					open={open}
					anchorEl={anchorEl}
					onClose={handleClickClose}
					anchorOrigin={{
						vertical   : 'bottom',
						horizontal : 'right'
					}}
					transformOrigin={{
						vertical   : 'top',
						horizontal : 'right'
					}}
				>
					<div className='flexCol pdngSM'>
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>All</span>
						</div>
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>My Questions</span>
						</div>
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>Not Answered</span>
						</div>
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>Upvote</span>
						</div>
						 {/* Approved and rejected is only for participants side */}
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>Approved</span>  {/* Approved is only for participants side*/}
						</div>
						<div className='flexRow gap8 aCntr'>
							<Checkbox color='primary' />
							<span>Rejected</span>  {/* Rejected is only for participants side*/}
						</div>
						<div className='flexRow jCntr aCntr pdngVXS'>
							<GradientButton variant='contained' fullWidth color='primary' onClick={handleClickClose}>Apply</GradientButton>

						</div>

					</div>
				</Popover>

			</div>
			<div className='flexCol qaBody'>
				<div className='flexRow pdngSM qaTab gap16'>
					<div className=' pdngHXXS'>

						{/* <Avatar >{getInitials()}</Avatar> */}

						<img src='/images/profile.svg' className='webQaProfile' />

					</div>
					<div className='flexMinWidthCol gap8'>
						<div className='flexRow'>

							<div className='flexMinWidthRow'>
								<span>John</span>
							</div>

							<div className='flexAutoRow pdngHSM gap8 aCntr'>
								<img src='/icons/upvote.svg' alt='upvote' className='AprrovedIcons pointer' />
								{/* <img src='/icons/upVoteG.svg' alt='upVoteG' className='AprrovedIcons pointer' /> */}

								<span className='upVoteTxt upVoteYellowTxt'>55</span>
								{/* <span className='upVoteTxt'>55</span> */}

							</div>

						</div>

						<small className='ellipse'>Hello choosing ethical hacking as a career is okay ? </small>
						{!reply &&
							<div className='flexRow  gap16'>
								<div className='flexInline gap8 aCntr pointer'>

									<img src='icons/reply.svg' alt='reply' className='AprrovedIcons' />
									<small className='link' onClick={() => setReply(true)}>Reply</small>
								</div>
								{/* <div className='flexInline gap8 aCntr pointer'>

									<small className='link'>Answered by you</small>
									<img src='icons/answeredByHost.svg' alt='answeredByHost' />

								</div> */}

								<div className='flexInline gap8 aCntr pointer'>
									<img src='icons/pin.svg' alt='pin' className='AprrovedIcons' />
									{/* <img src='icons/unPin.svg' alt='unpin' className='AprrovedIcons'/> */}

									<small className='link' >Pin on Screen</small>
									{/* <small className='errTxt' >Unpin on screen</small> */}

								</div>

								{/* Approved,pending,rejected will come in participant side only */}

								{/* <div className='flexInline hostApproveBtn'>

									<small>Approved</small>
								</div>
								<div className='flexInline hostPendingBtn'>

									<small>Pending</small>
								</div>
								<div className='flexInline hostRejectedBtn'>

									<small>Host rejected your question</small>
								</div> */}

							</div>
						}
						{reply &&
							<div className='flexRow gap8 aCntr'>
								<div className='flexMinWidthRow'>
									<FormControl fullWidth>
										<Input
											id='standard-adornment-password'
											type='text'
											endAdornment={
												<InputAdornment position='end'>
													<IconButton size='small' onClick={() => setReply(false)}>
														<SendIcon color='primary' fontSize='small' />
													</IconButton>
												</InputAdornment>
											}
										/>
									</FormControl>

								</div>
								<div className='flexAutoRow'>
									<img src='/icons/closeGBg.svg' alt='chatCloseIcon' className='chatCloseIcon' />
								</div>

							</div>

						}
						{/* <small>Yes you can choose , it will very definetly helpful to your
							Career. So you can choose ethical Hacking.</small> */}
					</div>
				</div>
				<div className='flexRow pdngSM qaTab gap16'>
					<div className=' pdngHXXS'>

						{/* <Avatar >{getInitials()}</Avatar> */}

						<img src='/images/profile.svg' className='webQaProfile' />

					</div>
					<div className='flexMinWidthCol gap8'>
						<div className='flexRow'>

							<div className='flexMinWidthRow'>
								<span>John</span>
							</div>

							<div className='flexAutoRow pdngHSM gap8 aCntr'>
								{/* <img src='/icons/upvote.svg' alt='upvote' className='AprrovedIcons pointer' /> */}
								<img src='/icons/upVoteG.svg' alt='upVoteG' className='AprrovedIcons pointer' />

								{/* <span className='upVoteTxt upVoteYellowTxt'>55</span> */}
								<span className='upVoteTxt'>55</span>

							</div>

						</div>

						<small className='ellipse'>Hello choosing ethical hacking as a career is okay ? </small>
						{!reply &&
							<div className='flexRow  gap16'>
								<div className='flexInline gap8 aCntr pointer'>

									<img src='icons/reply.svg' alt='reply' className='AprrovedIcons' />
									<small className='link' onClick={() => setReply(true)}>Reply</small>
								</div>

								{/* <div className='flexInline gap8 aCntr pointer'>

									<small className='link'>Answered by you</small>
									<img src='icons/answeredByHost.svg' alt='answeredByHost' />

								</div> */}
								<div className='flexInline gap8 aCntr pointer'>
									{/* <img src='icons/pin.svg' alt='pin' className='AprrovedIcons' /> */}
									<img src='icons/unPin.svg' alt='unpin' className='AprrovedIcons' />

									{/* <small className='link' >Pin on Screen</small> */}
									<small className='errTxt' >Unpin on screen</small>

								</div>

							</div>
						}
						{reply &&
							<div className='flexRow gap8 aCntr'>
								<div className='flexMinWidthRow'>
									<FormControl fullWidth>
										<Input
											id='standard-adornment-password'
											type='text'
											endAdornment={
												<InputAdornment position='end'>
													<IconButton size='small' onClick={() => setReply(false)}>
														<SendIcon color='primary' fontSize='small' />
													</IconButton>
												</InputAdornment>
											}
										/>
									</FormControl>

								</div>
								<div className='flexAutoRow'>
									<img src='/icons/closeGBg.svg' alt='chatCloseIcon' className='chatCloseIcon' />
								</div>

							</div>

						}
						{/* <small>Yes you can choose , it will very definetly helpful to your
							Career. So you can choose ethical Hacking.</small> */}
					</div>
				</div>
				<div className='flexRow pdngSM qaTab gap16'>
					<div className=' pdngHXXS'>

						{/* <Avatar >{getInitials()}</Avatar> */}

						<img src='/images/profile.svg' className='webQaProfile' />

					</div>
					<div className='flexMinWidthCol gap8'>
						<div className='flexRow'>

							<div className='flexMinWidthRow'>
								<span>John</span>
							</div>

							<div className='flexAutoRow pdngHSM gap8 aCntr'>
								<img src='/icons/upvote.svg' alt='upvote' className='AprrovedIcons pointer' />
								{/* <img src='/icons/upVoteG.svg' alt='upVoteG' className='AprrovedIcons pointer' /> */}

								<span className='upVoteTxt upVoteYellowTxt'>55</span>
								{/* <span className='upVoteTxt'>55</span> */}

							</div>

						</div>

						<small className='ellipse'>Hello choosing ethical hacking as a career is okay ? </small>
						{!reply &&
							<div className='flexRow  gap16'>
								{/* <div className='flexInline gap8 aCntr pointer'>

									<img src='icons/reply.svg' alt='reply' className='AprrovedIcons' />
									<small className='link' onClick={() => setReply(true)}>Reply</small>
								</div> */}

								<div className='flexInline gap8 aCntr pointer'>

									<small className='link'>Answered by you</small>
									<img src='icons/answeredByHost.svg' alt='answeredByHost' />

								</div>
								<div className='flexInline gap8 aCntr pointer' >
									<img src='icons/pin.svg' alt='pin' className='AprrovedIcons' />
									{/* <img src='icons/unPin.svg' alt='unpin' className='AprrovedIcons'/> */}

									<small className='link' >Pin on Screen</small>
									{/* <small className='errTxt' >Unpin on screen</small> */}

								</div>

							</div>
						}
						{reply &&
							<div className='flexRow gap8 aCntr'>
								<div className='flexMinWidthRow'>
									<FormControl fullWidth>
										<Input
											id='standard-adornment-password'
											type='text'
											endAdornment={
												<InputAdornment position='end'>
													<IconButton size='small' onClick={() => setReply(false)}>
														<SendIcon color='primary' fontSize='small' />
													</IconButton>
												</InputAdornment>
											}
										/>
									</FormControl>

								</div>
								<div className='flexAutoRow'>
									<img src='/icons/closeGBg.svg' alt='chatCloseIcon' className='chatCloseIcon' />
								</div>

							</div>

						}
						<small>Yes you can choose , it will very definetly helpful to your
							Career. So you can choose ethical Hacking.</small>
					</div>
				</div>
			</div>
			<div className='flexCol pdngSM'>
				<div className='flexRow inputCntr gap8'>
					<div className='flexMinWidthRow aCntr'>
						<input className='chatInput1' placeholder='Type Something' autoFocus id='message-container' />
					</div>
					<div className='flexAutoCol ' >
						<img className='pointer icons2' src='icons/send.svg' alt='icons' />
					</div>
				</div>
			</div>

			{/* <div className='flexCol jCntr aCntr approvedImgHg'>
				<img src='/images/approvedQa.svg' alt='pendingQa' className='pendingQaImg'/>
				<span className='pdngVSM sHdng'>No Questions Yet, You can ask your
					question</span>
			</div> */}
			{/* <div className='flexCol pdngSM'>
				<div className='flexRow inputCntr gap8'>
					<div className='flexMinWidthRow aCntr'>
						<input className='chatInput1' placeholder='Type Something' autoFocus id='message-container' />
					</div>
					<div className='flexAutoCol ' >
						<img className='pointer icons2' src='icons/send.svg' alt='icons' />
					</div>
				</div>
			</div> */}
		</div>
	);
}

export default WebQA;
